import { Stack, Typography } from "@mui/material"
import { SummaryLine } from "./summary-line"
import { CostFigure } from "./cost-figure"

export function CostSummaryFooter({ costResult, currencySymbol }) {
    return (
        <Stack alignItems="flex-end" spacing={0.5} sx={{ pt: 1, pb: 3 }}>
            <SummaryLine label="Trade Costs" value={costResult.maintenanceSubtotal} currencySymbol={currencySymbol} />
            <Stack
                direction="row"
                spacing={4}
                alignItems="baseline"
                sx={{ pt: 1, borderTop: 2, borderColor: "divider", mt: 1 }}
            >
                <Typography variant="h6">Total</Typography>
                <CostFigure
                    value={costResult.grandTotal}
                    currencySymbol={currencySymbol}
                    variant="h5"
                    fontWeight={700}
                />
            </Stack>
        </Stack>
    )
}
